/**
 * @file SVG text ellipsis
 * @author Christopher Hiller, Maarten Lensink
 * @see https://gist.github.com/boneskull/27f8003eeb605900a907ae8d8fd42c10
 */
import { ElementRef, OnInit } from '@angular/core';
/**
 * Simulates "text-overflow: ellipsis" on an SVG text node.
 */
/* tslint:disable */
var SvgEllipsisDirective = /** @class */ (function () {
    /**
     * Creates an instance of SvgEllipsisDirective.
     * @param {ElementRef} _el The SVG text requiring ellipsis at the end.
     */
    function SvgEllipsisDirective(_el) {
        this._el = _el;
        /** The character for three dots. */
        this.ellipsis = '\u2026';
    }
    /**
     * The ellipsis method is applied after initialization.
     */
    SvgEllipsisDirective.prototype.ngOnInit = function () {
        this._textEllipsis(this._el.nativeElement);
    };
    /**
     * Truncates the SVG text and adds an ellipsis, or three dots, in the end, if the text is longer than the given maximum width.
     * @param {SVGTextContentElement} el The SVG text that may need an ellipsis.
     */
    SvgEllipsisDirective.prototype._textEllipsis = function (el) {
        var text = this.text;
        if (!text || text.length === 0) { // Fix for #1545
            return;
        }
        if (typeof el.getSubStringLength !== 'undefined') {
            el.textContent = text;
            var len = text.length;
            if (el.getSubStringLength(0, len) > this.maxwidth) {
                while (el.getSubStringLength(0, len--) > this.maxwidth) {
                }
                el.textContent = text.slice(0, len) + this.ellipsis;
            }
        }
        else if (typeof el.getComputedTextLength !== 'undefined') {
            while (el.getComputedTextLength() > this.maxwidth) {
                text = text.slice(0, -1);
                el.textContent = "" + text + this.ellipsis;
            }
        }
        else {
            // The last fallback.
            while (el.getBBox().width > this.maxwidth) {
                text = text.slice(0, -1);
                // We need to update the textContent to update the boundary width.
                el.textContent = "" + text + this.ellipsis;
            }
        }
    };
    return SvgEllipsisDirective;
}());
export { SvgEllipsisDirective };
